export default {"src":"/_next/static/media/SUPERDAPP.18a988bf.svg","height":97,"width":427,"blurWidth":0,"blurHeight":0};